import { apiUrl } from "config/envConfig";
import http from "./httpService";

/**
 * Export a report for a given module (e.g., DriverManagement or CustomerManagement).
 *
 * @param {string} moduleType The type of report to export (e.g., 'DriverManagement', 'CustomerManagement').
 * @param {string} format     The file format to export ('csv', 'excel', 'pdf').
 *
 * @returns {Promise<void>} Triggers a download of the exported file.
 */
export const exportReport = async (moduleType, format) => {
  try {
    const response = await http.get(
      `${apiUrl}/user-mgmt/admin/reports/ExportReport/${moduleType}?format=${format}`,
      {
        responseType: "blob",
        headers: {
          Accept: "*/*",
        },
      }
    );

    const blob = new Blob([response.data]);
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${moduleType}.${format}`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    console.error("Export failed:", error);
    throw error;
  }
};

export const exportReportOrder = async (moduleType, format) => {
  try {
    const response = await http.get(
      `${apiUrl}/order-mgmt/admin/reports/ExportReport/${moduleType}?format=${format}`,
      {
        responseType: "blob",
        headers: {
          Accept: "*/*",
        },
      }
    );

    const blob = new Blob([response.data]);
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${moduleType}.${format}`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    console.error("Export failed:", error);
    throw error;
  }
};
